/*
 * E-letter reading page.
 *
 * Imported Mailchimp bodies are a flat run of <img> and <br> nodes, so a photo
 * strip that sat side by side in the email becomes one very tall column here.
 * This finds runs of consecutive images and lays them out in a grid instead,
 * which is the difference between a 3-screen scroll and a 12-screen one.
 */
(function () {
  'use strict';

  var isImage = function (node) {
    return node.nodeType === 1 && node.tagName === 'IMG';
  };

  /* <br>, comments and whitespace between two images don't break the run. */
  var isSkippable = function (node) {
    if (node.nodeType === 3) return node.textContent.trim() === '';
    if (node.nodeType === 8) return true;
    return node.nodeType === 1 && node.tagName === 'BR';
  };

  /* Consecutive images, ignoring the separators the importer leaves behind. */
  function findRuns(body, minimum) {
    var runs = [];
    var current = [];

    var flush = function () {
      if (current.length >= minimum) runs.push(current);
      current = [];
    };

    Array.prototype.forEach.call(body.childNodes, function (node) {
      if (isImage(node)) current.push(node);
      else if (!(current.length && isSkippable(node))) flush();
    });
    flush();

    return runs;
  }

  function layOutRun(images, columns) {
    var first = images[0];
    var last = images[images.length - 1];

    var grid = document.createElement('div');
    grid.className = 'nl-article__grid';
    grid.style.setProperty('--nlGridColumns', String(columns));
    first.parentNode.insertBefore(grid, first);

    // Drop only the separators sitting strictly between the first and last image.
    var node = first;
    while (node && node !== last) {
      var next = node.nextSibling;
      if (!isImage(node) && node.parentNode) node.parentNode.removeChild(node);
      node = next;
    }

    images.forEach(function (image) {
      var cell = document.createElement('span');
      cell.className = 'nl-article__grid__cell';
      grid.appendChild(cell);
      cell.appendChild(image);
    });
  }

  /*
   * Mailchimp sometimes puts a whole paragraph in a heading's <strong>. Anything this
   * long is body copy, not a title, so it gets paragraph styling in the CSS.
   */
  var HEADING_PARA_MIN_WORDS = 21;

  function markHeadingParagraphs(body) {
    var runs = body.querySelectorAll(
      'h1 strong, h2 strong, h3 strong, h4 strong, h5 strong, h6 strong, ' +
      'h1 b, h2 b, h3 b, h4 b, h5 b, h6 b'
    );

    Array.prototype.forEach.call(runs, function (run) {
      if (run.parentNode.closest('.nl-article__heading-para')) return;
      var words = run.textContent.trim().split(/\s+/).filter(Boolean).length;
      if (words >= HEADING_PARA_MIN_WORDS) run.classList.add('nl-article__heading-para');
    });
  }

  function start() {
    var bodies = document.querySelectorAll('[data-nl-article-body]');

    for (var i = 0; i < bodies.length; i++) {
      var body = bodies[i];
      if (body.dataset.nlGrouped) continue;
      body.dataset.nlGrouped = 'true';

      markHeadingParagraphs(body);

      var minimum = parseInt(body.getAttribute('data-nl-grid-min'), 10);
      var columns = parseInt(body.getAttribute('data-nl-grid-columns'), 10);
      if (!minimum || minimum < 2) continue;

      findRuns(body, minimum).forEach(function (images) {
        layOutRun(images, columns > 1 ? columns : 2);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', start);
})();
